import styled from 'styled-components';
import Screen from 'src/styles/Themes/Screen';
import { radius } from 'src/styles/Themes/Metrics';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { borders } from '@/styles/Themes/Metrics';
import ErrorMessage from '@/shared/images/icons/ErrorMessage';
import Palette from '@/styles/Themes/Palette';

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
`;

export const Label = styled.label`
    height: 20px;
    margin-bottom: 5px;
    color: ${cssVars.fg_gray1_white};
    padding: 5px 0;
    ${Text.Mobile.medium.semibold};

    ${Screen.ipad} {
        ${Text.Ipad.caption.semibold};
        margin-bottom: 10px;
    }
    ${Screen.desktop} {
        margin-bottom: 15px;
    }
`;

export const Input = styled.input`
    height: 40px;
    border-radius: ${radius.large};
    border: ${borders.small} ${cssVars.fg_gray3_dark1};
    background-color: ${cssVars.bg_white_dark3};
    color: ${cssVars.fg_gray2_gray3};
    font-size: ${Text.Mobile.medium.medium};
    padding: 5px 30px;

    ${Screen.ipad} {
        ${Text.Ipad.caption.medium};
        height: 50px;
    }
    ${Screen.desktop} {
        ${Text.Desktop.medium.medium};
    }

    &:focus {
        border: ${borders.small} ${cssVars.fg_gray2_gray3};
    }
`;

export const ErrorText = styled.div`
    ${Text.Mobile.normal.semibold};
    display: flex;
    align-items: center;
    position: relative;
    background: ${cssVars.bg_lightBg_darkBg};
    border-radius: ${radius.small};
    border: ${borders.small} ${cssVars.bg_gray4_dark2};
    color: ${Palette.state.error};
    height: 33px;
    top: 10px;
    padding: 8px 15px;
    box-shadow: ${cssVars.shadow_card_default};

    ${Screen.ipad} {
        ${Text.Ipad.small.semibold};
    }

    ${Screen.desktop} {
        height: 40px;
    }

    &:before {
        content: '';
        height: 8px;
        width: 8px;
        border-top: ${borders.small} ${cssVars.bg_gray4_dark2};
        border-right: ${borders.small} ${cssVars.bg_gray4_dark2};
        background: ${cssVars.bg_lightBg_darkBg};
        border-left: none;
        border-bottom: none;
        transform: rotate(-45deg);
        position: absolute;
        top: -6px;
        left: 30px;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    gap: 17px;
    ${Screen.ipad} {
        gap: 27px;
    }
    ${Screen.desktop} {
        padding: 0 60px;
        gap: 22px;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-top: 50px;
    padding: 0 30px;
`;

export const InfoContainer = styled.div`
    background-color: ${cssVars.bg_white_blue};
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_card_default};
    padding: 16px 20px 20px;
    margin: 20px 0 0;
    width: 100%;

    ${Screen.ipad} {
        margin: 24px 0 0;
    }

    ${Screen.desktop} {
        max-width: 50%;
        min-width: 230px;
        padding: 30px 25px;
        margin: 0;
    }
`;

export const IconWrapper = styled.div`
    padding: 0 10px;
`;

export const ErrorIcon = styled(ErrorMessage)``;
